import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionsCreators from "actions/competition";
import Box from '../article'

class ArticlePage extends Component {


  render() {
    let {id}=this.props.match.params;
    let { article } = this.props.competition;

    return (
      <Box id={id}  link={'promote'}>
        <div className="comp-content">
        <h2>宣传片</h2>
          {article && article.cp_xc_file?
          <div
            className="article-content">
              <video src={article.cp_xc_file} controls style={{width:'100%'}}></video>
            </div>
            :null}
        </div>
      </Box>
    );
  }
}

export default connect(
  state => state,
  dispatch => bindActionCreators(actionsCreators, dispatch)
)(ArticlePage);
